const getProductInventoryChannels = (serverInventory)=>{
    var ref;
    return serverInventory === null || serverInventory === void 0 ? void 0 : (ref = serverInventory.items) === null || ref === void 0 ? void 0 : ref.map((serverInventoryItem)=>({
            key: serverInventoryItem.channel.key,
            id: serverInventoryItem.channel.id,
            quantity: serverInventoryItem.quantity
        })
    );
};

export { getProductInventoryChannels };
//# sourceMappingURL=get-product-inventory-channels.js.map
